import React, { useState } from "react";
import FormContainer from "../formContainer/formContainer.js";
import { useResourcesList } from "../../../hooks/useResourcesList.js";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton.js";
export default function ResourceSelector(props) {
    const [resourcesList, getResource] = useResourcesList();
    const [menuOpened, setMenuOpened] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    return (React.createElement("div", null,
        React.createElement(Button, { text: "Wybierz zas\u00F3b", onClick: () => setMenuOpened(true) }),
        props.state && (React.createElement(React.Fragment, null,
            React.createElement("br", null),
            "Wybrano zas\u00F3b:",
            " ",
            typeof props.state === "string" ? props.state : props.state.name)),
        menuOpened && (React.createElement(FormContainer, { notify: () => { }, inputs: [
                {
                    type: "select",
                    name: "watermark",
                    label: "Wybierz zasób",
                    params: {
                        options: resourcesList.map((resource) => ({
                            label: resource.name,
                            value: resource.name,
                        })),
                    },
                },
            ], isLoading: isLoading, onSubmit: async (results) => {
                setIsLoading(true);
                const resource = await getResource(results.watermark.value);
                setIsLoading(false);
                props.onSelect(resource);
                setMenuOpened(false);
            }, onReject: () => setMenuOpened(false) }))));
}
